var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-full-screen',{staticClass:"book-ride",attrs:{"overlay":""}},[_c('n-dialog',{attrs:{"name":"book-ride"}}),_c('n-scrollable',[_c('web-header'),_c('div',{staticClass:"book-ride-wrapper"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }